import type { ModalIbanAccountStep, QuizStepProps } from "@/features/user/quiz/types.ts";
import { useTranslation } from "react-i18next";
import { SectionTitleSmall } from "@/atoms-react/text/Text.react.tsx";
import InputLabel from "@/atoms-react/input/Input.react.tsx";
import DotsNavigation from "@/atoms-react/dots-navigation/DotsNavigation.react.tsx";
import { Button } from "@/atoms-react/button/Button.react.tsx";
import { Themes } from "@/types/theme.ts";
import { CountryInput } from "@/molecules/form-add-address/index.react.tsx";
import { AddressCreate } from "@/features/user/types";

export const CommercialRegisterInfoStep = ({
  setStep,
  quizResponses,
  setQuizResponses,
  stepSettings,
  setPrevStep,
  totalSteps = 8
}: QuizStepProps) => {
  const { t } = useTranslation(["pass"]);

  const handleCountryChange = (selectedOption: AddressCreate) =>
    setQuizResponses?.((prev) => ({
      ...prev,
      register_info: { ...prev.register_info, country: selectedOption.country?.toString() ?? null }
    }));
  const handleRadioBoxChange = (selectedOption) =>
    setQuizResponses?.((prev) => ({
      ...prev,
      register_info: { ...prev.register_info, number: selectedOption }
    }));
  const isQuizAnswered = () => {
    if (
      quizResponses?.register_info?.country == null ||
      quizResponses?.register_info?.country == ""
    ) {
      return false;
    }
    if (
      quizResponses?.register_info?.number === null ||
      quizResponses?.register_info?.number == ""
    ) {
      return false;
    }
    return true;
  };
  const { country } = quizResponses?.register_info ?? {};
  const countryInputAddressProps: AddressCreate = {
    country: country ? Number.parseInt(country) : null,
    tag: "",
    zip: "",
    address: "",
    city: ""
  };
  return (
    <>
      <SectionTitleSmall>
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.register_info.question")}
      </SectionTitleSmall>

      <div className="mb-4 flex min-w-full flex-col justify-center">
        <CountryInput address={countryInputAddressProps} onChange={handleCountryChange} />
      </div>
      <SectionTitleSmall>
        {t("olkypass.mainPage.olkypass.modalOpenOlkyPay.steps.register_info.inscription_number")}
      </SectionTitleSmall>

      <div className="mt-4 mb-4 flex min-w-full flex-col justify-center">
        <InputLabel
          autoFocus
          placeholder={"1234"}
          required={false}
          className={"pb-4"}
          value={quizResponses?.register_info?.number as string}
          onChange={(value: string) => handleRadioBoxChange(value)}
        />
      </div>
      <div className="mt-auto mb-4 flex flex-col items-center">
        <DotsNavigation total={totalSteps + 3} current={stepSettings.current} className="mb-4" />
        <div className="flex w-full flex-col-reverse gap-y-2 md:flex-row md:gap-x-2">
          <Button
            theme={Themes.white}
            onClick={() => setPrevStep(stepSettings.previous as ModalIbanAccountStep)}
          >
            {t("olkypass.general.go_back")}
          </Button>

          <Button
            disabled={!isQuizAnswered()}
            onClick={() => setStep(stepSettings.next as ModalIbanAccountStep)}
          >
            {t("olkypass.general.continue")}
          </Button>
        </div>
      </div>
    </>
  );
};
